import { useRef} from 'react';
import logo from './logo.webp';
// import office1 from './images/office1.webp';
import './App.css';
// import Schedule from './schedule';
import { useNavigate } from 'react-router-dom';
// import NavMenu from './NavMenu';
// import vid1 from './videos/vid1.mp4';


function App() {
  //   const [linkNameInProgress, setLinkNameInProgress] = useState("vfrnr");
  //   const [linkName, setLinkName] = useState("vfrnr");

  var about = useRef(null);

  //   function calendyInlay(){
  //     if(linkName == "") {
  //       return(<div>Nothing Yet</div>);
  //     } else {
  //         return (
  //             <div  className="calendly-inline-widget" data-url={"https://calendly.com/" + linkName}  style={{minWidth:"30%", height:"70vh",zIndex:1000}}>
  //               <script data-allow="payment" type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
  //             </div>
  //           )
  //     }
  // }

  // function handleInput(currName: React.ChangeEvent<HTMLInputElement>) {
  //   setLinkNameInProgress(currName.target.value);
  // }

  // function checkKey(e: React.KeyboardEvent<HTMLInputElement>){
  // if(e.key === "Enter") {
  //   setLinkName(linkNameInProgress);
  //    alert(linkNameInProgress);
  //   }
  // }
  const navigate = useNavigate();


  const goToSchedulePage = () => {
    navigate('/schedule');
  };

  function openExternalLink(url: string) {
  window.open(url, '_blank');
}


function globalNavigation(destination: string) {
  // const navigate = useNavigate();
  navigate(destination);
}

function emphasize(text:string,color:string = '#038df6'){
  if(color){
    return <span className="emphasisSpan" style={{color:color}}>{text}</span>
  } else {
      return <span className="emphasisSpan">{text}</span>
  }
}

  return (
    <>
      {/* <input type="text" value={linkNameInProgress} onChange={(e) => handleInput(e)} onKeyDown={(e)=>checkKey(e)}></input> */}

      <div className="landingPageItemCenter" style={{ margin: 0, padding: 0,maxHeight:"80vh",overflow:"hidden" }}>
        <video style={{}}autoPlay muted playsInline loop>
                    <source src={"/videos/redbirdDescentClip1-3.mp4"}></source>
        </video>
      </div>
    <div className="separator">
                                          {/* <button onClick={() => openExternalLink("https://calendly.com/vfrnr")}>See Services</button>

                          <img src={logo} style={{justifySelf:"center", alignSelf:"center",maxWidth:"150px"}}></img>

                          <button onClick={() => openExternalLink("https://calendly.com/vfrnr")}>See Services</button> */}
    </div>


      {/* <div ref={about} className="landingPageItemOdd">
        <img src={office1}></img>
        <p>Flight Simulator Time Rental on an FAA Certified Redbird TD2 Simulator</p>
      </div>

      <div className="landingPageItemEven">
        <p>Flight Simulator Time Rental on an FAA Certified Redbird TD2 Simulator</p>
        <img src={redbird1}></img>
      </div> */}

      <div className="landingPageItemCenter">
        <h1 id="services"style={{color:"#0479ffff",textDecoration:"underline",textDecorationColor:"#FFBB04",textUnderlineOffset:"0.5rem"}}>Services</h1>
        <div className="genericGrid3Col">

          <div className="gridItem">
            <img alt="redbird" src={"/imagesPublic/redbird3.JPG"}></img>
            <div className="gridItemContent">
              <h2>Practice Beyond the Airplane</h2>
              <p>Student Pilots to Commercial Pilots can benefit from learning and practicing in the simulated environment. Build your procedural and avionics proficiency in a controlled environment.</p>
            </div>
          </div>

          <div className="gridItem">
            <img alt="redbird"  src={"/imagesPublic/redbird4.webp"}></img>
            <div className="gridItemContent">
              <h2>IFR Currency</h2>
              <p>Maintain your IFR currency. Log simulated instrument time towards your {emphasize("6 approaches, Intercepts, and Tracking")} for IFR currency per 61.57(c)(2)</p>
            </div>
          </div>

          <div className="gridItem">
            <img alt="redbird"  src={"/imagesPublic/redbird2.webp"}></img>
            <div className="gridItemContent">
              <h2>Avionics Proficiency</h2>
              <p>Prioritze safety and become proficient with steam or glass panel configurations. Practice visual or instrument operations on the {emphasize("G1000")} avionics suite.  <br></br><br></br>Increase your {emphasize("safety margins","red")}, save {emphasize("time and costs")}, and practice on your schedule. </p>
            </div>
          </div>


          <div className="gridItem">
            <img alt="redbird"  src={"/imagesPublic/redbird5.webp"}></img>
            <div className="gridItemContent">
              <h2>Independent CFIs</h2>
              <p>Independent CFIs can utilize the space and simulator to conduct ground lessons with students, demonstrating maneuvers and procedures on the {emphasize("Redbird TD2","#A70D13")} simulator to enhance student understanding and retention.</p>
            </div>
          </div>

          <div className="gridItem">
            <img alt="redbird" src={"/imagesPublic/redbird2.webp"}></img>
            <div className="gridItemContent">
              <h2>Student Pilots</h2>
              <p>Log hours towards your Private Pilot's License. Log up to {emphasize("2.5 hours")} under the supervision of a qualfied instructor towards your Private Pilot Certificate per 61.109(k)(1)</p>
            </div>
          </div>


          <div className="gridItem">
            <img alt="redbird" src={"/imagesPublic/redbird2.webp"}></img>
            <div className="gridItemContent">
              <h2>Instrument Students</h2>
              <p>Log hours towards your Instrument Rating. Log up to {emphasize("10 Hours")} under the supervision of a qualfied instructor towards your Instrument Rating per 61.65(i)</p>
            </div>
          </div>




          {/* <div className="gridItem">
            <img alt="redbird"  src={"/imagesPublic/redbird6.webp"}></img>
            <div className="gridItemContent">
              <h2>Private Environment</h2>
              <p>Private Environment on the Treasure Coast with Office, Desk, Computer, and Aviation Training Supplies for independent CFI's to conduct ground lessons with a co-located simulator for easy access to demonstration & practice tools for their students.</p>
            </div>

          </div> */}

          {/* <div className="gridItem">
            <img alt="redbird" src={logo}></img>
            <div className="gridItemContent">
              <h2>Co-located Office Space</h2>
              <p> Located near Downtown Stuart in a Thriving plaza. Located Right above: Ichimaru. Located Near: Epic Theaters, Toojays </p>
            </div>
          </div> */}

          {/* <div className="gridItem">
            <img src={logo}></img>
            <div className="gridItemContent">
              <h2>Dedicated Simulator Space</h2>
              <p> Dedicated Space for: Mock Checkrides, Simulator Training, IFR Training, IFR Currency</p>
            </div>
          </div> */}
        </div>  
        {/* <button onClick={() => openExternalLink("https://calendly.com/vfrnr")}>Reserve Time Now!</button> */}
        {/* <button onClick={() => {globalNavigation("simulator")}}>Indicate Interest</button> */}

      <button style={{color:"white",backgroundColor:"red"}}className="focusItem" onClick={() => {globalNavigation("earlyAccess");}}>Early Access Form</button>

      </div>

    </>
  );
}

export default App;
